import React, { useState, useEffect, useContext } from "react";

import db from "../../services/query";

import lbl from "../../data/Labels.json";

import Lists from "./_lists/Lists";
import CardItems from "./CardItems";
import MainBodyTabs from "./financeTabs";

import MainTitle from "../common/MainTitle";
import MainPrintLink from "../common/MainPrint";

import { HalfYearContext } from "../../contexts/halfYearContext";

const FinanceRevenues = (props) => {
  const { match } = props;

  const [tabs, setTabs] = useState([]);
  const { halfYear } = useContext(HalfYearContext);

  const routeTabs = [
    {
      name: "درآمد ها",
      path: "/mis/revenues/1",
    },
    {
      name: "بودجه ها",
      path: "/mis/revenueBudgets",
    },
    {
      name: "تخفیف ها",
      path: "/mis/discounts",
    },
  ];

  useEffect(async () => {
    const ac = new AbortController();

    await db.getAll("revenues/types").then(({ data }) => {
      setTabs(data);
    });

    return () => ac.abort();
  }, [halfYear]);

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.Revenues} />
        </div>
        <div className="left-content">
          <MainPrintLink path={`revenues/${match.params.tid}/${halfYear}`} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={routeTabs} {...props} />
        <CardItems
          path="revenues"
          cards={tabs.data}
          restClass={`mt-25`}
          currentTab={match.params.tid}
        />
        <Lists currentTab={match.params.tid} />
      </div>
    </div>
  );
};

export default FinanceRevenues;
